// Session-level unlock for the "verify OTP to view driver details" gate.
// Verifying once unlocks viewing ANY driver's details for a fixed 10-minute window
// from the moment of verification (no extension on activity -- a new OTP is required
// once that window elapses, even if the admin stayed continuously active). Leaving the
// driver-details page for any other module clears the unlock immediately, so returning
// always requires a fresh OTP.

const STORAGE_KEY = "driverViewUnlockedUntil";
export const DRIVER_VIEW_UNLOCK_WINDOW_MS = 10 * 60 * 1000;

export function isDriverViewUnlocked(): boolean {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return false;
  const unlockedUntil = Number(raw);
  return !Number.isNaN(unlockedUntil) && Date.now() < unlockedUntil;
}

export function markDriverViewUnlocked(windowMs: number = DRIVER_VIEW_UNLOCK_WINDOW_MS): void {
  sessionStorage.setItem(STORAGE_KEY, String(Date.now() + windowMs));
}

export function clearDriverViewUnlock(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
